import React from "react";
import './download-format.scss';
import {Dropdown} from "../../../dropdown";
import {updateFormat} from "../../download-publish-modal-reducer";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormatItem} from "../format-item";
import {ANALYTICS_DOWNLOAD_CATEGORY, FILE_FORMAT_PDF} from "../../../../libraries/download-panel-library";

/**
 * This component is specifically written for the file type/format dropdown in the download dialog.
 *
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */


export class DownloadFormat extends React.Component {

    constructor(props) {
        super(props);
        this.#setDefaultFormatForTheSelectedProduct()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.#setDefaultFormatForTheSelectedProduct();
    }

    render = () => {
        let validFormats = this.#getValidFormatsForSelectedProduct();
        if (validFormats && validFormats.length > 0) {
            return <div className={'format-container'}>
                <h3 className={'section-heading body-s-bold'}>{i18next.t('pmwjs_file_type')}</h3>
                <div className={'format-list'}>
                    <Dropdown defaultDataValue={this.#getDefaultFormatId(validFormats)}
                              dropdownItems={this.#prepareFormatList(validFormats)}
                              dropdownClasses={'format-dropdown -primary'}
                              clickHandler={this.#onFormatSelected}
                              portalDomId={'download-panel-dropdown-portal'}
                              title={i18next.t('pmwjs_file_type')}
                              showDropdownAsModalForMobile={true}
                    />
                </div>
            </div>
        } else {
            return null
        }

    }

    /**
     * Handler for when the format is selected, updates the format in the store
     * @param {string} itemId
     */
    #onFormatSelected = (itemId) => {
        PMW.redux.store.dispatch(updateFormat(itemId));
    }

    /**
     * Returns valid formats applicable on the selected product
     * @returns {*|null}
     */
    #getValidFormatsForSelectedProduct = () => {
        return this.props.formatList[this.props.selectedProduct.id] ? this.props.formatList[this.props.selectedProduct.id] : null;
    }

    /**
     * @param {Array} listItems
     * @returns {*}
     */
    #prepareFormatList = (listItems) => {
        return (
            listItems.map((item) => {
                return {
                    label: <FormatItem format={item}/>,
                    dataValue: item.id,
                }
            })
        )
    }

    #setDefaultFormatForTheSelectedProduct() {
        const validFormats = this.#getValidFormatsForSelectedProduct();
        if (validFormats) {
            PMW.redux.store.dispatch(updateFormat(this.#getDefaultFormatId(validFormats)))
        }
    }

    /**
     * @param {array} formats
     * @returns {null|*}
     */
    #getDefaultFormatId = (formats) => {
        if (formats.length > 0) {
            if (this.#isPDFDownload()) {
                return formats.find(x => x.id === FILE_FORMAT_PDF).id
            }

            return formats[0].id
        }
        return null;
    }

    /**
     * We consider a download as a  PDF download when the product is a large size image
     * @returns {boolean}
     */
    #isPDFDownload = () => {
        return !this.props.selectedProduct.isVideo && this.props.selectedProduct.isLargeSize
    }
}

const mapDownloadFormatStateToProps = state => {
    return {
        selectedProduct: state.downloadPanel.selectedProduct,
        formatList: state.downloadPanel.formatList
    }
}


DownloadFormat.propTypes = {
    /**
     * Selected product form the DownloadProducts component
     */
    selectedProduct: PropTypes.object.isRequired,
    /**
     * List of available formats
     */
    formatList: PropTypes.object.isRequired

}

export default connect(mapDownloadFormatStateToProps)(DownloadFormat)